module.exports = __webpack_public_path__ + "static/flags/IR-8223ecf0515a60f47430d6197a558f79.gif";